__webpack_require__.p = "https://kosa-nostra.com/";